<template>
  <b-container fluid class="table px-6">
    <b-row>
      <b-col md="8" class="mt-3">
        <b-form-group label="Список доступных серверов:" class="mb-1">
          <b-form-radio-group
            id="radio-group-1"
            v-model="selectedServer"
            :options="servers"
            value-field="server_alias"
            text-field="server_name"
            @change="serverCheck"
          ></b-form-radio-group>
        </b-form-group>
      </b-col>
    </b-row>
    <b-row>
      <b-col offset-md="auto" class="pr-0">
        <div class="buttons">
          <b-button
            class="b-upper"
            variant="success"
            @click="dealerData({}, { add:true })">
            + Добавить дилера
          </b-button>
        </div>
      </b-col>
    </b-row>
    <div class="d-flex">
      <div v-if="this.items && this.items.length" class="filtered-items-number mr-auto">Записи с
        {{ currentPage === 1 ? this.setFirstItem() : ((currentPage-1)*this.pageOptionSelected)+1 }} до
        {{ this.calcItems() }} из
        {{ this.items.length }}
      </div>
    </div>
    <b-table
      hover
      show-empty
      responsive
      id="mytable"
      ref="mytable"
      :fields="fields"
      :items="items"
      :busy.sync="isBusy"
      :no-provider-paging="true"
      :no-provider-sorting="true"
      :no-provider-filtering="true"
      :current-page="currentPage"
      :per-page="perPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      empty-text="Нет данных в таблице">
      <template v-slot:cell(dilerName)="data">
        {{ data.item.name }}
      </template>

      <template v-slot:cell(inn)="data">
        <span v-if="data.item.inn">{{ data.item.inn }}</span><span v-if="data.item.kpp">/{{ data.item.kpp }}</span>
      </template>

      <template v-slot:cell(price)="data">
        <span style="white-space: pre-line;">{{ data.item.price.length > 0 ? data.item.price.join('\n') : '' }}</span>
      </template>

      <template v-slot:cell(price_date)="data">
       <span style="white-space: pre-line;">{{ data.item.price_date.length > 0 ? priceDate(data.item.price_date) : '' }}</span>
      </template>

      <template v-slot:cell(actions)="data">
        <div>
          <b-button class="more-info"
                    :id="data.item.id +'popover'"><i class="fas table fa-ellipsis-h"></i>
          </b-button>
          <b-popover :target="data.item.id +'popover'"
                     triggers="focus">
            <ul class="popoverButtons">
              <li @click="dealerData(data.item, { add:false })"><i class="fas fa-pencil-alt"></i>
                <span>Редактировать дилера</span>
              </li>
              <li @click="$router.push({ path: `/administration/dealers-prices/${data.item.id}`})"><i class="fas fa-file-invoice"></i>
                <span>Прайсы</span>
              </li>
            </ul>
          </b-popover>
        </div>
      </template>

      <div slot="table-busy" class="text-xl-center text-lg-center text-md-center text-sm-left text-left text-secondary my-2">
        <b-spinner class="align-middle mr-2"></b-spinner>
        <strong>Загружаем данные...</strong>
      </div>
    </b-table>

    <div class="main-footer">
      <b-form inline>
        <label class="mr-3">Показать</label>
        <b-form-select :options="pageOptions"
                       v-model="perPage"
                       @change="saveOptionSelected"/>
      </b-form>
      <b-pagination align="center"
        prev-text="&lt;"
        first-text="&lt;&lt;"
        next-text="&gt;"
        last-text="&gt;&gt;"
        :total-rows="totalRows"
        :per-page="perPage"
        v-model="currentPage"
        class="my-6">
      </b-pagination>
    </div>
    <dealer @goToFirstPage="goToFirstPage" ref="dealer" @reloadDealers="reloadDealers"></dealer>
  </b-container>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex'
import moment from 'moment'
import Dealer from './modalForms/Dealer'

export default {
  name: 'DealersPrices',
  components: {
    Dealer
  },
  data () {
    return {
      fields: [
        { key: 'dilerName', label: 'Дилер', sortable: false },
        { key: 'inn', label: 'ИНН/КПП', sortable: false },
        { key: 'price', label: 'Активный прайс', sortable: false },
        { key: 'price_date', label: 'Дата применения прайса', sortable: false },
        { key: 'actions', label: 'Дополнительно', sortable: false }
      ],
      items: null,
      currentPage: 1,
      totalRows: null,
      perPage: 10,
      pageOptions: [5, 10, 20, 50],
      sortBy: 'id',
      sortDesc: true,
      sortDirection: 'asc',
      item: {},
      pageOptionSelected: 10,
      selectedServer: null
    }
  },
  watch: {
    items () {
      this.totalRows = this.items.length
    }
  },
  mounted () {
    this.selectedServer = localStorage.getItem('citadelDealerServer') ? localStorage.getItem('citadelDealerServer') : this.servers[0].server_alias
    this.getDealers(this.selectedServer).then(
      () => {
        this.items = JSON.parse(JSON.stringify(this.dealers))
      }
    )
    this.getBillingTypes()
  },
  methods: {
    moment: function (date) {
      moment.locale('ru')
      return moment(date)
    },
    serverCheck () {
      localStorage.setItem('citadelDealerServer', this.selectedServer)
      this.getDealers(this.selectedServer).then(
        () => {
          this.items = JSON.parse(JSON.stringify(this.dealers))
        }
      )
    },
    priceDate (dates) {
      const datesNew = dates.map((item) => {
        const parts = item.split('-')
        return this.moment(new Date(parts[1], parts[0] - 1)).format('MM.YYYY')
      })
      return datesNew.join('\n')
    },
    setFirstItem () {
      if (this.items.length < 1) {
        return 0
      } else {
        return 1
      }
    },
    saveOptionSelected (event) {
      this.pageOptionSelected = event
    },
    calcItems () {
      if (this.currentPage === 1) {
        if ((this.currentPage) + this.pageOptionSelected < this.items.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.items.length
        }
      } else {
        if (((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected < this.items.length) {
          return ((this.currentPage - 1) * this.pageOptionSelected) + this.pageOptionSelected
        } else {
          return this.items.length
        }
      }
    },
    dealerData (data, add) {
      const dataAdd = data
      dataAdd.add = add.add
      dataAdd.server = this.servers[0].server_alias
      this.$refs.dealer.modalDealer(dataAdd)
    },
    reloadDealers () {
      this.getDealers(this.selectedServer).then(
        () => {
          this.items = JSON.parse(JSON.stringify(this.dealers))
        }
      )
    },
    ...mapActions({
      getGroupsUsers: 'groupsUsers/getGroupsUsers',
      getBillingTypes: 'groupsUsers/getBillingTypes',
      getDealers: 'dealers/getDealers'
    }),
    ...mapMutations('groupsUsers', [
      'setActiveElement'
    ]),
    goToFirstPage () {
      this.currentPage = 1
    }
  },
  computed: {
    ...mapState(
      {
        isBusy: state => state.dealers.isBusy,
        dealers: state => state.dealers.dealers,
        userInfo: state => state.authorization.userInfo
      }
    ),
    ...mapGetters(
      {
        groupsUsers: 'groupsUsers/filteredGroupsUsers'
      }
    ),
    servers () {
      const arr = []
      this.userInfo.piportals.map(item => {
        arr.push({ server_name: item.name, server_alias: item.alias })
      })
      return arr
    }
  }
}
</script>

<style scoped>
  .table.red {
    color: #e7161a;
  }
  .table.orange {
    color: #fdb611;
  }

  .container_search-close {
    position: absolute;
    right: 11px;
    top: 9px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 22px;
    height: 22px;
    z-index: 4;
  }

  .container_search-close:hover {
    border-radius: 50%;
    background-color: #acacac;
  }

  .search-close {
    font-size: 18px;
    color: #acacac;
    cursor: pointer;
    line-height: 18px;
    width: 18px;
    text-align: center;
    margin-bottom: 2px;
  }

  .container_search-close:hover > span {
    color: #fff;
  }

  #select-status, #select-dealer {
    font-size: 14px;
    height: 40px;
  }

  .opacity {
    opacity: 0.6;
  }

  .popover.popover-body {
    padding: 0;
  }

  .qwerty {
    display: flex;
    flex-direction: column;
  }

  p.copy:hover i.fa-copy {
    visibility: visible;
  }

  i.fa-copy {
    visibility: hidden;
    margin: 0;
  }

  .buttons-holder {
    display: flex;
    visibility: hidden;
  }

  button.b-table {
    padding: 0.1rem 0.375rem;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-right: 0.75rem;
    border: 2px solid #cfd8dc;
  }

  button.b-table:hover {
    color: #fff;
  }

  tr:hover .buttons-holder, .b-table-has-details .buttons-holder {
    visibility: visible;
  }

  .buttons-holder_subgroup {
    display: flex;
    visibility: hidden;
  }

  .subgroups:hover .buttons-holder_subgroup {
    visibility: visible;
  }

  .table .table {
    background-color: unset;
  }

  .user_card_button {
    font-size: 16px;
    color: #78909C;
    margin-right: 0;
    visibility: hidden;
  }

  .user_card_button:hover {
    color: #37474F;
  }

  .user_card:hover .user_card_button {
    visibility: visible;
  }

  .more-info {
    display: flex;
    align-items: center;
    background-color: unset;
    padding: 0;
    margin: 0;
    border: none;
    box-shadow: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    padding: 0.1rem 0.375rem;
  }

  .more-info > .table {
    font-size: 20px;
  }

  .btn-secondary:not(:disabled):not(.disabled):active {
    background-color: #Fff;
  }

  select {
    -webkit-appearance: none;
    cursor: pointer;
  }

  .td_wrapper {
    display: flex;
    flex-direction: column;
  }

  i.table {
    width: 20px;
    height: 20px;
    color: #78909C;
    font-size: 16px;
    line-height: 20px;
    text-align: center;
    margin-right: 8px;
  }

  i.fa-search {
    width: 36px;
    height: 36px;
  }

  p.main-name {
    font-family: "PT Root UI Bold", Tahoma, Geneva, Verdana, sans-serif !important;
    color: #37474F;
    font-size: 16px;
    line-height: 20px;
    margin-bottom: 0;
  }

  p.normal {
    color: #37474F;
    font-size: 14px;
    letter-spacing: 0.25px;
    line-height: 16px;
    display: inline-flex;
    align-items: baseline;
    margin-bottom: 8px;
  }

  p.subgroup {
    display: inline-flex;
    color: #37474F;
    font-size: 14px;
    letter-spacing: 0.25px;
    line-height: 16px;
    margin-bottom: 0;
    align-items: baseline;
    word-break: break-all;
  }

  .bold {
    font-weight: bold;
  }

  .users {
    margin: 0;
  }

  .inline {
    display: inline-flex;
    align-items: center;
    margin-bottom: 8px;
  }

  .b-table {
    padding: 0.275rem;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    margin-right: 0.75rem;
    border: 2px solid #cfd8dc;
    color: #78909c;
  }

  .btn.b-table:hover i {
    color: #fff;
  }

  .user_data {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    /*flex-wrap: wrap;*/
  }

  .user_group {
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    flex-wrap: wrap;
  }

  .user_card {
    height: 100%;
    padding: 8px;
    box-shadow: 0 2px 8px 0 rgba(0, 0, 0, 0.25);
  }

  .user_card:hover {
    cursor: pointer;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.3);
  }

  .user-subgroup {
    display: flex;
    flex-direction: column;
    margin: 0;
    flex-wrap: nowrap;
    /*border: 4px solid #CFD8DC;*/
  }

  .subgroups {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 6px 15px;
    margin: 0 -15px;
    background-color: #F5F7F8;
    min-height: 44px;
  }

  .set-active {
    background-color: #c3e6cb;
  }

  .subgroup_items {
    display: inline-flex;
    align-items: center;
  }

  .cards .card {
    margin: 5px;
  }

  .custom-select {
    font-size: 12px;
  }

  .buttons {
    display: flex;
    justify-content: flex-end;
  }

  .user-button {
    display: flex;
    justify-content: flex-start;
  }

  .remove-user-button {
    display: flex;
    justify-content: flex-end;
  }

  .main-footer {
    display: flex;
    justify-content: space-between;
  }

  .table {
    margin-bottom: 0;
  }

  #mytable {
    width: 100%;
    table-layout: fixed;
  }

  .wrap {
    display: flex;
    justify-content: flex-end;
  }

  table.b-table > thead > tr > th.sorting::after, table.b-table > tfoot > tr > th.sorting::after {
    right: 0.75em;
  }

  ul.rights {
    padding: 0;
  }

  .input-group > .form-control:not(:last-child), .input-group > .custom-select:not(:last-child) {
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    font-size: 14px;
    height: 40px;
  }

  .input-group i {

    right: 0px;
    position: absolute;
    pointer-events: none;
    padding: 10px;
    z-index: 99;
    color: #9ba3a7;
  }

  li.rights {
    list-style: none;
    border: #37474F 1px solid;
    background-color: #546E7A;
    margin: 5px;
    padding: 5px;
    border-radius: 5px;
    color: #ffffff;
    text-align: center;
  }

  .buttons-box {
    display: flex;
  }

  ul.popoverButtons {
    list-style: none;
    cursor: pointer;
    margin-right: 0rem;
    border: none;
    color: #78909c;
    margin-bottom: 0;
    padding-inline-start: 0;
    width: 100%;
  }

  ul.popoverButtons > li {
    padding: 9px;
  }

  ul.popoverButtons > li:not(:last-child) {
    padding: 9px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.2);
  }

  ul.popoverButtons > li > span {
    font-size: 14px;
    line-height: 20px;
    color: #37474F;
  }

  ul.popoverButtons > li > i {
    height: 24px;
    width: 24px;
    font-size: 16px;
    text-align: center;
    margin-right: 4px;
  }

  ul.popoverButtons > li:hover {
    padding: 9px;
    background-color: #ECEFF1;
  }

  .b-upper {
    margin-right: 1rem;
  }

  .buttons-holder_subgroup {
    display: flex;
    visibility: hidden;
  }

  .subgroups:hover .buttons-holder_subgroup {
    visibility: visible;
  }

  .filtered-items-number {
    font-size: 14px;
  }

  .user-create-info {
    font-size: 13px !important;
  }
</style>
